import {useQuery} from '@apollo/client'
import React, {useEffect} from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import {Button, Offcanvas} from 'react-bootstrap'
import {useDisclourse} from '../../../hooks/useDisclourse'
import {SignatureFormsEntriesTimeline} from '../../signatureFormsEntries/components/SignatureFormsEntriesTimeline'
import {ModalRequestSignature} from '../../signatureForms/components/ModalRequestSignature'
import {IResSignatureFormsEntriesAPI} from '../../../types/signatureFormsEntriesApi'
import {GET_ALL_SIGNATURE_FORMS_ENTRIES_API} from '../../../gql/queries/signatureFormsEntriesApiQueries'

interface ConsentRequestTabProps {
  policyInfo: {id: string; user: string; emailAddress?: string; phone?: string; isQuote?: boolean}
}

export const ConsentRequestTab: React.FC<ConsentRequestTabProps> = ({policyInfo}) => {
  const intl = useIntl()
  const {
    data: dataEntriesByPolicy,
    error,
    loading,
    refetch: refetchEntries,
  } = useQuery<IResSignatureFormsEntriesAPI>(GET_ALL_SIGNATURE_FORMS_ENTRIES_API, {
    variables: {policy: policyInfo.id},
    fetchPolicy: 'network-only', // para que siempre consulte desde el servidor
  })

  useEffect(() => {
    if (error)
      toast.error(
        intl.formatMessage(
          {id: 'common.error.withMessage', defaultMessage: 'Error: {message}'},
          {message: error.message}
        )
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])
  const {isOpen, onClose, onOpen} = useDisclourse()

  return (
    <>
      <Offcanvas.Header className='kt-heading--md custom-border-brand'>
        <Offcanvas.Title className='d-flex align-items-center gap-4'>
          <FormattedMessage
            id='policies.detail.tab.consent.title'
            defaultMessage='Consent Requests'
          />
        </Offcanvas.Title>
        <Button size='sm' onClick={onOpen} variant='info'>
          <i className='bi bi-vector-pen fs-4' /> <FormattedMessage
            id='policies.detail.tab.consent.request'
            defaultMessage='Request Consent'
          />
        </Button>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className='m-3'>
          <SignatureFormsEntriesTimeline
            loading={loading}
            dataEntriesByLead={dataEntriesByPolicy?.allSignatureFormsEntries}
            refetch={refetchEntries}
          />
        </div>
      </Offcanvas.Body>
      {isOpen && (
        <ModalRequestSignature
          keyboard={false}
          backdrop='static'
          isOpen={isOpen}
          sourceId={policyInfo.id}
          sourceType='policy'
          onClose={onClose}
          refetch={refetchEntries}
          preAgentId={policyInfo.user}
          hasEmail={Boolean(policyInfo.emailAddress && policyInfo.emailAddress.trim() !== '')}
          hasPhone={Boolean(policyInfo.phone && policyInfo.phone.trim() !== '')}
        />
      )}
    </>
  )
}
